var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('banner'),_c('switch-nav',{attrs:{"index":_vm.index,"fixed":_vm.fixed},on:{"onClick":_vm.handleNavClick}}),_c('tools-download',{attrs:{"index":_vm.index}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }